import React, { useEffect, useState } from 'react';
import AuthUser from '../services/AuthUser';
import { useNavigate } from 'react-router-dom';



const TicketList = () => {
  const [email, setEmail] = useState('');
  const [tickets, setTickets] = useState([]);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const { http } = AuthUser();
  const navigate = useNavigate();

  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem('user'));
    const savedEmail = sessionStorage.getItem('ticket_email');
    const savedTickets = sessionStorage.getItem('ticket_data');

    if (savedTickets && savedEmail) {
      setEmail(savedEmail);
      setTickets(JSON.parse(savedTickets));
      return;
    }

    if (savedUser?.email) {
      setEmail(savedUser.email);

      // Auto-fetch tickets
      http.get(`/tickets?author_email=${encodeURIComponent(savedUser.email)}`)
        .then(res => {
          setTickets(res.data);
          sessionStorage.setItem('ticket_email', savedUser.email);
          sessionStorage.setItem('ticket_data', JSON.stringify(res.data));
          if (res.data.length === 0) {
            setStatus('No tickets found for this email.');
          } else {
            setStatus(null);
          }
        })
        .catch(err => {
          console.error('Error fetching tickets:', err);
          setStatus('Error fetching tickets. Please try again.');
          setTickets([]);
        })
        .finally(() => setLoading(false));
    }
  }, []);


  const handleFetch = (e) => {
    e.preventDefault();

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setStatus('Please enter an email.');
      setTickets([]);
      return;
    }

    setLoading(true);
    setStatus(null);

    http.get(`/tickets?author_email=${encodeURIComponent(trimmedEmail)}`)
      .then(res => {
        setTickets(res.data);
        sessionStorage.setItem('ticket_email', trimmedEmail);
        sessionStorage.setItem('ticket_data', JSON.stringify(res.data));
        if (res.data.length === 0) {
          setStatus('No tickets found for this email.');
        } else {
          setStatus(null);
        }
      })
      .catch(err => {
        if (err.response?.status === 403 && err.response?.data?.requires_login) {
          setStatus(err.response.data.message);
        } else {
          console.error('Error fetching tickets:', err);
          setStatus('Error fetching tickets. Please try again.');
        }
        setTickets([]);
      })

      .finally(() => setLoading(false));
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value.trim()) {
      setTickets([]);
      setStatus(null);
      sessionStorage.removeItem('ticket_email');
      sessionStorage.removeItem('ticket_data');
    }
  };

  useEffect(() => {
    const savedEmail = sessionStorage.getItem('ticket_email');
    const savedTickets = sessionStorage.getItem('ticket_data');

    if (savedEmail && savedTickets) {
      setEmail(savedEmail);
      setTickets(JSON.parse(savedTickets));
    }
  }, []);

  return (
    <div>
      <h4>Search Tickets by Email</h4>

      <form onSubmit={handleFetch}>
        <div className="form-group">
          <input
            type="email"
            className="form-control"
            placeholder="Enter your email"
            value={email}
            onChange={handleEmailChange}
            required
            disabled={loading}
          />
        </div>

        <button className="btn btn-primary mb-3" type="submit" disabled={loading}>
          {loading ? 'Loading...' : 'Fetch Tickets'}
        </button>
      </form>

      {status && (
        <div
          className="alert alert-info"
          dangerouslySetInnerHTML={{ __html: status }}
        />
      )}


      {tickets.length > 0 ? (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Author</th>
              <th>Status</th>
              <th>Comments</th> {/* New column for comment count */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map(ticket => (
              <tr
                key={ticket.id}
                className={ticket.has_admin_reply ? '' : ''}
              >
                <td>{ticket.id}</td>
                <td>{ticket.title}</td>
                <td>{ticket.author_name} ({ticket.author_email})</td>
                <td>{ticket.status?.name ?? '-'}</td>
                <td>
                  <div className="d-flex align-items-center">
                    <span>{ticket.comments_count ?? 0}</span>
                    {ticket.has_admin_reply && (
                      <span className="badge bg-success ms-2 py-2 px-2">New Reply</span>
                    )}
                  </div>
                </td>

                <td>
                  <button
                    className="btn btn-sm btn-info"
                    onClick={() => navigate(`/ticket/tickets/${ticket.id}`)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        !loading && email.trim() && <div>No tickets to display.</div>
      )}
    </div>
  );
};

export default TicketList;
